// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__21jSO","imageUploader":"EGiftCard_imageUploader__2FhZS"};